import formConfig from '../ca-form-config.json';
import type { FieldDef, SectionDef, TemplateGroup, RefDataItem } from '../../shared/composables/useFormRenderer';
import { useFormRenderer } from '../../shared/composables/useFormRenderer';

export type { FieldDef, SectionDef, TemplateGroup, RefDataItem };

// ===== Composable =====
export function useFormConfig() {
  const { sharedRefData, sharedTemplates, resolveTemplate: _resolveTemplate, resolveGroup: _resolveGroup, getRefOptions } = useFormRenderer();

  const sections = formConfig.sections as SectionDef[];
  // Use shared templates (address template from form-templates.json)
  const templates: Record<string, FieldDef[]> = { ...sharedTemplates };

  const refData: Record<string, RefDataItem[]> = { ...sharedRefData };

  /**
   * Resolve template ref to field array
   */
  function resolveTemplate(ref: string, includeOptional?: boolean): FieldDef[] {
    return _resolveTemplate(templates, ref, includeOptional);
  }

  /**
   * Resolve a template group into fields
   */
  function resolveGroup(group: TemplateGroup): FieldDef[] {
    return _resolveGroup(templates, group);
  }

  return {
    formConfig,
    sections,
    templates,
    refData,
    resolveTemplate,
    resolveGroup,
    getRefOptions,
  };
}
